import {PaginationSettings} from '@deviceinsight/ng-ui-api-client';

const paginationSettingsAll: PaginationSettings = {
	page: 0,
	size: 10000,
	sort: {
		property: 'name',
		direction: 'ASC'
	}
};
export {paginationSettingsAll};
